import classes from './Layout.module.css';
import { useParams, Redirect } from 'react-router-dom';
import { useEffect, useState } from 'react';

// IMPORT OWN COMPONENTS
import Footer from './Footer';
import Header from './Header';
import EmergencyButton from '../UI/EmergencyButton';

// IMPORT DATA
import { globals } from '../../data/global-vars';
import CompareButton from '../UI/CompareButton';
import Popup from '../UI/Popup';
import { Helmet } from 'react-helmet';
import { useBrandFind, usePageFind } from '../../hooks/useFinders';
import { ThemeProvider, createTheme } from '@mui/material';
// import { useContext } from 'react';
// import CompareContext from '../../store/compare-context';
import useFetchContent from '../../hooks/useFetchContent';
import { getApiUrl } from '../../config/api';

const ScreenIndicator = () => {
  return (
    <div className="fixed bottom-2 right-2 z-[9999] pointer-events-none text-xs font-mono text-white">
      <div className="block sm:hidden bg-pink-600 px-2 py-1 rounded">xs</div>
      <div className="hidden sm:block md:hidden bg-green-600 px-2 py-1 rounded">
        sm
      </div>
      <div className="hidden md:block lg:hidden bg-yellow-600 px-2 py-1 rounded">
        md
      </div>
      <div className="hidden lg:block xl:hidden bg-blue-600 px-2 py-1 rounded">
        lg
      </div>
      <div className="hidden xl:block 2xl:hidden bg-indigo-600 px-2 py-1 rounded">
        xl
      </div>
      <div className="hidden 2xl:block bg-purple-600 px-2 py-1 rounded">
        2xl
      </div>
    </div>
  );
};

function Layout(props) {
  const params = useParams();
  const page = params.page;
  const brand = params.brand;
  const brandObject = useBrandFind(brand);
  const pageObject = usePageFind(page);
  const { getSingleText: fetchSingleText } = useFetchContent();
  let content = null;

  const [descriptionText, setDescriptionText] = useState('');
  useEffect(() => {
    if (brand === globals.BRANDS.SKODA.url) {
      fetchSingleText('646f41f4d906fa7cc1e9246c', (d) => {
        setDescriptionText(d.text);
      });
    } else
      fetchSingleText('63cd0463b5887e97e3569e46', (d) => {
        setDescriptionText(d.text);
      });
  }, [brand]);

  function checkValidBrand(brand) {
    let urls = [];
    Object.values(globals.BRANDS).map((item) => {
      return (urls = [...urls, item.url]);
    });
    if (urls.indexOf(brand) < 0) {
      return false;
    } else return true;
  }

  function checkValidPage(page) {
    let pages = [];
    Object.values(globals.PAGES).map((item) => {
      return (pages = [...pages, item.url]);
    });
    if (pages.indexOf(page) < 0) return false;
    else return true;
  }

  Object.values(globals.PAGES).map((item) => {
    if (item.url === page) return (content = item.content);
    else return null;
  });

  useEffect(() => {
    if (
      page !== globals.PAGES.DETAIL.url &&
      page !== globals.PAGES.NEUWAGEN.url &&
      page !== globals.PAGES.GEBRAUCHTWAGEN.url
    ) {
      localStorage.removeItem('carsLoadedArray');
      localStorage.removeItem('detailId');
    }
  }, [page]);

  useEffect(() => {
    if (page === globals.PAGES.DETAIL.url)
      document.documentElement.style.setProperty('--ccm-bottom', '72px');
    else document.documentElement.style.setProperty('--ccm-bottom', '32px');
  }, [page]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--primary-color',
      brandObject.primeColorHex
    );
  }, [brandObject]);

  const theme = createTheme({
    palette: {
      primary: {
        main: brandObject.primeColorHex,
      },
    },
  });
  useEffect(() => {
    window.AuEmbed = window.AuEmbed || {
      config: {
        peviewUrl: getApiUrl('/details' + window.location.pathname),
      },
    };
  }, []);

  if (!checkValidBrand(brand))
    return <Redirect to={`/${globals.BRANDS.VW.url}/${page}/`}></Redirect>;
  else if (!checkValidPage(page))
    return (
      <Redirect to={`/${brand}/${globals.PAGES.STARTSEITE.url}/`}></Redirect>
    );
  else
    return (
      <ThemeProvider theme={theme}>
        <div className={classes.wrapper}>
          <Helmet>
            <meta name="theme-color" content={brandObject.primeColorHex} />
            <meta
              name="description"
              content={descriptionText
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/g, ' ')
                .replace(/([^ ])\.([^ ])/g, '$1. $2')}
            />
          </Helmet>
          {checkValidBrand(brand)}
          {checkValidPage(page)}
          <Header />
          <Popup />
          {props.children}
          <div className={classes.container}>{content}</div>
          {!pageObject.hideInNav && <CompareButton />}
          {page === globals.PAGES.STARTSEITE.url && <EmergencyButton />}

          {process.env.REACT_APP_IS_DEV === 'true' && <ScreenIndicator />}
          <Footer />
        </div>
      </ThemeProvider>
    );
}

export default Layout;
